import * as Styled from './styles'

export default function TitleBanner({ children }) {
  return <Styled.Title>{children}</Styled.Title>
}
